import React from 'react';
import Button from '@material-ui/core/Button';

export default (props) => (
    <Button {...props} color="primary" variant="outlined">
        {props.children}
    </Button>
);